import { useEffect } from 'react'
import { useRouter } from '@tanstack/react-router'

/**
 * Advances keyboard/screen reader focus to <main> on every route change.
 * Satisfies AC4 — ensures screen reader users are oriented after navigation.
 * Must be rendered inside <RouterProvider> (i.e. within a route component).
 */
export function RouterFocusManager() {
  const router = useRouter()

  useEffect(() => {
    return router.subscribe('onResolved', () => {
      requestAnimationFrame(() => {
        const main = document.querySelector<HTMLElement>('main')
        main?.focus()
      })
    })
  }, [router])

  return null
}
